import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M27.86,15.25l-3.4-1.5L16.22,18a.49.49,0,0,1-.44,0L7.54,13.75l-3.4,1.5a.48.48,0,0,0,0,.88l11.66,6a.43.43,0,0,0,.44,0l11.66-6A.48.48,0,0,0,27.86,15.25Z' }),
  React.createElement('path', { d: 'M27.86,22.22l-3.4-1.51-8.24,4.22a.43.43,0,0,1-.44,0L7.54,20.71l-3.4,1.51a.48.48,0,0,0,0,.88l11.66,6a.49.49,0,0,0,.44,0l11.66-6A.48.48,0,0,0,27.86,22.22Z' }),
  React.createElement('path', { d: 'M27.88,9l-11.66,6a.49.49,0,0,1-.44,0L4.12,9a.48.48,0,0,1,0-.88L15.8,2.92a.47.47,0,0,1,.4,0L27.86,8.07A.48.48,0,0,1,27.88,9Z' })
));